import { Controller } from "@hotwired/stimulus"

// A membership registration screen (TMS-1760, TMS-1761). Continue waits until every required field
// has an answer: the fields named in `required` (a select's value, a chosen radio, a ticked box, or
// at least one chip or selection for a list), and any "please specify" field marked `required`
// while it is showing. A named field that is only present disabled — a question hidden because an
// earlier answer made it not apply — asks nothing. Text typed into a chip field but not yet added
// counts — it is added when the form is sent. Every address on the screen (address-entry) must be
// complete too. While Continue waits, `pendingNote` says what it is waiting for. The server checks
// all of this again (Memberships::SaveRegistrationStepService).
export default class extends Controller {
  static targets = ["submit", "required", "pendingNote"]
  static values = { required: Array }

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasSubmitTarget) return

    const data = new FormData(this.element)
    const answered = (name) =>
      data.getAll(name).some((value) => String(value).trim() !== "") || this.pendingChip(name) || this.notAsked(name)
    const missing = this.requiredValue.some((name) => !answered(name)) ||
      this.requiredTargets.some((field) => !field.disabled && field.value.trim() === "") ||
      this.addressElements().some((element) => !this.addressComplete(element))

    this.submitTarget.disabled = missing
    if (this.hasPendingNoteTarget) this.pendingNoteTarget.hidden = !missing
  }

  notAsked(name) {
    const fields = Array.from(this.element.elements).filter((field) => field.name === name)
    return fields.length > 0 && fields.every((field) => field.disabled)
  }

  // Addresses still on the screen; one removed again is hidden, and asks nothing.
  addressElements() {
    return Array.from(this.element.querySelectorAll("[data-controller~='address-entry']"))
      .filter((element) => !element.hidden)
  }

  // Asked of the address's own controller rather than remembered from its events, which may come
  // before this controller connects.
  addressComplete(element) {
    const address = this.application.getControllerForElementAndIdentifier(element, "address-entry")
    return Boolean(address && address.complete() && !address.pending)
  }

  pendingChip(name) {
    const chips = Array.from(this.element.querySelectorAll("[data-controller~='chip-input']"))
      .find((element) => element.dataset.chipInputNameValue === name)
    const field = chips?.querySelector("[data-chip-input-target='field']")
    return Boolean(field && field.value.trim() !== "")
  }
}
